export class SpreadsheetPageRemoveDto {
    constructor(public TableId: number,
                public EntityRecordId: number,
                public PageField: string,
                public PageName: string) {

    }
}